import React from 'react'
import clsx from 'clsx';
import { ReactComponent as IconFirst } from 'images/pagination-first.svg';
import { ReactComponent as IconLast } from 'images/pagination-last.svg';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.scss';

type PaginationProps = {
  className?: string,
  page: number,
  pageCount: number,
  onPageChange: (id: number) => void,
}

function Pagination({
  className = '',
  page,
  pageCount,
  onPageChange,
}: PaginationProps) {
  const handlePageChange = (e: any) => {
    onPageChange(e?.selected)
  }
  return (
    <ReactPaginate
      className={clsx(styles.container, className)}
      breakLabel="..."
      nextLabel={<IconLast />}
      previousLabel={<IconFirst />}
      onPageChange={handlePageChange}
      pageRangeDisplayed={5}
      forcePage={page}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
      breakClassName={styles.break}
      pageClassName={styles.item}
      pageLinkClassName={styles.itemLink}
      activeClassName={styles.active}
      activeLinkClassName={styles.activeLink}
      previousClassName={styles.previous}
      previousLinkClassName={styles.previousLink}
      nextClassName={styles.next}
      nextLinkClassName={styles.nextLink}
    />
  )
}

export default Pagination
